/**
 * Two-step confirmation for destructive actions (Borrar / Cancelar /
 * etc.). The first prompt describes WHAT will happen; the second asks
 * the user to acknowledge that it's irreversible. Both must be
 * answered Aceptar for the action to proceed.
 *
 * Returns true only when the user clicked OK on both prompts.
 */
export function confirmDestructive(
  primaryMessage: string,
  finalMessage = "Esta acción no se puede deshacer. ¿Confirmar?"
): boolean {
  if (!window.confirm(primaryMessage)) return false;
  if (!window.confirm(finalMessage)) return false;
  return true;
}
